define('views/components/reseller_personal/reseller_personal',['require','backbone','text!templates/components/reseller_personal/reseller_personal.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/reseller_personal/reseller_personal.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'reseller-personal-item'
    });
});
